'use strict';

var einstein = {
	// storage elements
	registeredEinsteinListeners: {},
	loaded: window.einstein.loaded || [],
	load: function (id) {
		einstein.loaded.push(id);
		var einstainElement = $('#' + id);
		if (einstainElement.hasClass('einstain-inited')) {
			return window.console.log('einstain-inited', id);
		}
		for (var selector in this.registeredEinsteinListeners) {
			if (this.onEinstainContentAdded(selector, this.registeredEinsteinListeners[selector])) {
				return window.console.debug('einstain-event-triggered', id, selector);
			}
		}
	},
	// binds function to moment when Einstein content added, if present on page it's executed instantly
	// return true if function is executed
	onEinstainContentAdded: function (selector, callback) {
		// check if element present in dom
		var einsteinContainers = $('[id^="cq_recomm_slot"]:not(.einstain-inited)');
		var targetElements = einsteinContainers.find(selector);
		// store callback for all time, as it can be executed instantly and with delayed load
		this.registeredEinsteinListeners[selector] = callback;
		if (targetElements && targetElements.length) {
			// mark container as loaded if required child is already present
			targetElements.each(function () {
				$(this).parents('[id^="cq_recomm_slot"]').addClass('einstain-inited');
			});
			// call callback with small delay, to make sure elements processed before it
			setTimeout(callback, 200);
			return true;
		}
		return false;
	}
};

module.exports = einstein;
window.einstein = einstein;
